export const PASSWORD_LENGTH = 8;